"use strict";

var startCase = require('lodash/startCase');

module.exports = function (accumulator, order, product, component) {
  return accumulator + (!component.employee_name ? '' : "-".concat(startCase(component.employee_name)));
};